import { tweenValue } from "./tween.js";

function textConstant(value) {
  return function () {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function () {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

export default function (value) {
  return this.tween("text", typeof value === "function" ? textFunction(tweenValue(this, "text", value)) : textConstant(value == null ? "" : value + ""));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-transition/src/transition/text.js
// module id = 539
// module chunks = 0